import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarItemDefinition } from '../../../common/model/sidebar-item';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-dashboard-menu',
    templateUrl: './dashboard-menu.component.html',
    styleUrls: ['./dashboard-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardMenuComponent implements OnInit {
  @Input() menuItems: Observable<SidebarItemDefinition[]>;
  constructor() {}

  ngOnInit(): void {}
}
